module.exports = __webpack_public_path__ + "img/gs.4c23e997.svg";